import LiveSearch from "./LiveSearch";
import LiveSources from "./LiveSources";

const LiveFooterMenu = () => {
  return (
    <div
      data-tour="live-orders.filters"
      className="flex w-full flex-wrap items-center gap-8 p-2"
    >
      <LiveSearch />
      <LiveSources />
    </div>
  );
};

export default LiveFooterMenu;
